var React = require('react');

function MTVConnected (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"49.476","y":"14.664","fill":"#FCEE21","width":"101.048","height":"170.672","key":0}),React.createElement("rect",{"x":"60.567","y":"24.522","fill":"#4BACEC","width":"78.867","height":"130.623","key":1}),React.createElement("circle",{"fill":"#4BACEC","cx":"100","cy":"170.549","r":"8.259","key":2})]));
}

MTVConnected.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 200","enableBackground":"new 0 0 200 200","xmlSpace":"preserve"};

module.exports = MTVConnected;

MTVConnected.default = MTVConnected;
